import { DesignChannel } from 'components/NewFileModal/Types'

export const DesignChannelsNames: Record<DesignChannel, string> = {
  [DesignChannel.InstagramPost]: 'instagram post',
  [DesignChannel.InstagramStory]: 'instagram story',
  [DesignChannel.InstagramReel]: 'instagram reel',
  [DesignChannel.FacebookPost]: 'facebook post',
  [DesignChannel.LinkedInPost]: 'linkedIn post',
  [DesignChannel.TwitterPost]: 'x/twitter post',
  [DesignChannel.TwitterProfilePicture]: 'x/twitter profile picture',
  [DesignChannel.TwitterCoverImage]: 'x/twitter cover image',
  [DesignChannel.TikTokPost]: 'tiktok post',
  [DesignChannel.TikTokThumbnail]: 'tiktok thumbnail',
  [DesignChannel.YoutubeChannelArt]: 'youtube channel art',
  [DesignChannel.YoutubeProfilePicture]: 'youtube profile picture',
  [DesignChannel.FacebookCover]: 'facebook cover',
  [DesignChannel.FacebookProfilePicture]: 'facebook profile picture',
  [DesignChannel.FacebookMarketplace]: 'facebook marketplace',
  [DesignChannel.LinkedInBanner]: 'linkedin banner',
  [DesignChannel.LinkedInProfilePicture]: 'linkedin profile picture',
  [DesignChannel.WhatsAppSticker]: 'whatsapp sticker',
  [DesignChannel.Pinterest]: 'pinterest post',
  [DesignChannel.Ebay]: 'eBay product post',
  [DesignChannel.Poshmark]: 'poshmark product post',
  [DesignChannel.Depop]: 'depop product post',
  [DesignChannel.Mercari]: 'mercari product post',
  [DesignChannel.MercadoLibre]: 'mercado libre product post',
  [DesignChannel.Shopee]: 'shopee product post',
  [DesignChannel.Lazada]: 'lazada product post',
  [DesignChannel.Etsy]: 'etsy product post',
  [DesignChannel.Vinted]: 'vinted product post',
  [DesignChannel.Amazon]: 'amazon product post',
  [DesignChannel.Shopify]: 'shopify product post',
  [DesignChannel.Post]: 'post',
  [DesignChannel.YoutubeShort]: 'youtube short',
  [DesignChannel.GoogleMyBusinessPost]: 'google business profile post',
}
